module.exports = __webpack_public_path__ + "img/go-stack-test-min.049ad3df.jpg";